export default "__VITE_ASSET__COt_dKfK__"